import React from 'react';
import SGSIcon from '../Basic';

type Props = React.HTMLAttributes<HTMLElement> & {
    onClick?: () => void;
};

const SGSEditIcon: React.FC<Props> = ({ ...props }) => {
    return <SGSIcon title="global.edit" icon="fas fa-pencil-alt" {...props} />;
};

export default SGSEditIcon;
